export default "__VITE_ASSET__BuP41wAN__"